/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-case-declarations */
/* eslint-disable no-shadow */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import cookies from 'react-cookies';
import api from '../../services/api';
import Table from '../../components/TableContracts';
import ExportButton from '../../components/ExportButton';
import NavPages from '../../components/NavPages';
import BoxContainer from '../../components/BoxContainer';
import Counter from './components/Counter';
import { Container, FilterBox, Contracts, Title } from './styles';

export interface dataServerDTO {
  created_at: string;
  creditor: dataTableInfo;
  debtor: dataTableInfo;
  due_date: string;
  total_value: string;
  id: number;
  percentage_value: string;
  status: string;
  updated_at?: string;
}

export interface dataTableInfo {
  affiliation_key: string;
  document: string;
  fantasy_name: string;
  id: number;
  legal_name: string;
  on_registry: boolean;
  stone_code: string;
}

export interface columsTable {
  header: string;
  accessor: string;
}

export interface TableContent {
  columns: columsTable[];
  data: dataServerDTO[];
  dataMobile: dataServerDTO[];
  barProgress: boolean;
  loading: boolean;
}

const columns = [
  {
    header: 'ID',
    accessor: 'id',
  },
  {
    header: 'CPF / CNPJ',
    accessor: 'title',
  },
  {
    header: 'Razão Social',
    accessor: 'socialName',
  },
  {
    header: 'Início',
    accessor: 'start',
  },
  {
    header: 'Fim',
    accessor: 'end',
  },
  {
    header: '%',
    accessor: 'percent',
  },
  {
    header: 'Limite',
    accessor: 'limit',
  },
  {
    header: 'Status',
    accessor: 'status',
  },
];

const Dashboard: React.FC = () => {
  const [active, setActive] = useState(0);
  const [pending, setPending] = useState(0);
  const [rejected, setRejected] = useState(0);
  const [expired, setExpired] = useState(0);

  const [barProgress, setBarProgress] = useState(false);

  const [boxFilter, setBoxFilter] = useState(0);
  const [dataServer, setDataServer] = useState<dataServerDTO[]>([]);
  const [dataTable, setDataTable] = useState<dataServerDTO[]>([]);
  const [currentDataTableList, setCurrentDataTableList] = useState<
    dataServerDTO[]
  >([]);
  const [loading, setLoading] = useState(false);

  cookies.remove('proposalInfoClient');

  function compare(a: any, b: any) {
    if (a.id > b.id) {
      return -1;
    }
    if (a.id < b.id) {
      return 1;
    }
    return 0;
  }

  async function dbSearch() {
    const { data } = await api.get(
      `/v0/gps/merchants/${cookies.load('external_stone_codes')}/proposals`,
      {
        headers: {
          Authorization: `Bearer ${cookies.load('external_token')}`,
        },
      },
    );

    if (data !== null) {
      if (JSON.stringify(data) !== JSON.stringify(dataServer)) {
        setLoading(true);

        if (cookies.load('external_tags'))
          if (!!cookies.load('external_tags').gps_recebedor) {
            setDataServer(data.creditor.sort(compare));
            localStorage.setItem(
              'tableServer',
              JSON.stringify(data.creditor.sort(compare)),
            );
          } else if (!!cookies.load('external_tags').gps_originador) {
            const temp = data.debtor.filter((item: any) => {
              return item.status !== 'ED';
            });
            setDataServer(temp.sort(compare));
            localStorage.setItem(
              'tableServer',
              JSON.stringify(temp.sort(compare)),
            );
          }
        setBoxFilter(0);
      }
    }
    setBarProgress(false);
    setLoading(false);
  }

  useEffect(() => {
    const temp = localStorage.getItem('tableServer');
    let dataCookies;
    if (temp) {
      setBarProgress(true);
      dataCookies = JSON.parse(temp);
      setDataServer(dataCookies);
      dbSearch();
    } else {
      setLoading(true);
      dbSearch();
    }
  }, []);

  // Define os dados da tabela principal
  useEffect(() => {
    setDataTable(dataServer);
  }, [dataServer]);

  // Contador de Proposta por status
  useEffect(() => {
    let countActive = 0;
    let countPending = 0;
    let countRejected = 0;
    let countExpired = 0;
    dataServer.map((status: { status: string }) => {
      switch (status.status) {
        case 'AP':
          countActive += 1;
          break;
        case 'RE':
          countRejected += 1;
          break;
        case 'PE':
          countPending += 1;
          break;
        case 'ED':
          countPending += 1;
          break;
        case 'DI':
          countExpired += 1;
          break;
        default:
          break;
      }
      setActive(countActive);
      setExpired(countExpired);
      setPending(countPending);
      setRejected(countRejected);
      return 1;
    });
  }, [dataServer, boxFilter]);

  // Filtro pelo status da proposta
  function setActiveFilter(x: number) {
    if (x === boxFilter) {
      setBoxFilter(0);
      setDataTable(dataServer);
    } else {
      switch (x) {
        case 1:
          setBoxFilter(1);
          const active = dataServer.filter((active: { status: string }) => {
            return active.status === 'AP';
          });
          setDataTable(active);
          break;
        case 2:
          setBoxFilter(2);
          const reject = dataServer.filter((rejected: { status: string }) => {
            return rejected.status === 'RE';
          });
          setDataTable(reject);
          break;
        case 3:
          setBoxFilter(3);
          const pendingAndEdition = dataServer.filter(
            (pending: { status: string }) => {
              if (pending.status === 'PE' || pending.status === 'ED') {
                return pending;
              }
            },
          );
          setDataTable(pendingAndEdition);
          break;
        case 4:
          setBoxFilter(4);
          const expired = dataServer.filter((active: { status: string }) => {
            return active.status === 'DI';
          });
          setDataTable(expired);
          break;
        default:
          setDataTable(dataServer);
          break;
      }
    }
  }

  const dataCurrentTable = (dataCurrentTable: dataServerDTO[]) => {
    setCurrentDataTableList(dataCurrentTable);
  };

  return (
    <Container>
      <FilterBox>
        <Counter
          type={1}
          active={boxFilter}
          text="Ativas"
          setActiveFilter={setActiveFilter}
          duration={2.75}
          data={active}
        />
        <Counter
          type={3}
          active={boxFilter}
          text="Pendentes"
          setActiveFilter={setActiveFilter}
          duration={2.75}
          data={pending}
        />
        <Counter
          type={2}
          active={boxFilter}
          text="Rejeitadas"
          setActiveFilter={setActiveFilter}
          duration={2.75}
          data={rejected}
        />
        <Counter
          type={4}
          active={boxFilter}
          text="Finalizadas"
          setActiveFilter={setActiveFilter}
          duration={2.75}
          data={expired}
        />
        <div id="mobileFilterAdjust" />
      </FilterBox>
      <Contracts>
        <Title>
          <h3 style={{ color: '#0DB14B', fontSize: 24, fontFamily: 'Roboto' }}>
            Gestão de Propostas
          </h3>
          <div
            style={{
              display: 'flex',
              flex: 1,
              height: 1,
              background: '#0DB14B',
              marginRight: 20,
              marginLeft: 20,
            }}
          />
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <ExportButton data={dataTable} />
            <NavPages dataTable={dataTable} onSubmit={dataCurrentTable} />
          </div>
        </Title>
      </Contracts>
      <BoxContainer>
        <Table
          dataMobile={dataTable}
          data={currentDataTableList}
          columns={columns}
          loading={loading}
          barProgress={barProgress}
        />
      </BoxContainer>
    </Container>
  );
};
export default Dashboard;
